import { useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import TickUBD from "../../../assets/images/TickUBD.svg";
import CrossUBD from "../../../assets/images/CrossUBD.svg";
import editName from "../../../assets/images/editName.svg";
import { changeDateFormat, validateUBDSpecialChar } from "../../../utils";
import { spcialCharAlert, textFieldMaxLength } from "../../../constants";
import { CharacterLimit } from "../../common/CharacterLimit/CharacterLimit";

import "./index.scss";

export default function FullkitHeader({
  isEditMode,
  setIsEditMode = null,
  fullkitName,
  initialFullkitName,
  projectName,
  setFullkitName,
  setInitialFullkitName,
  errorAlert,
  setErrorAlert,
  taskListOptions,
  isTaskPage = false,
  selectedTaskList,
  setSelectedTaskList = null,
  CFKDesignDisabled,
  handleProjectNameClick = null
}) {
  const { TaskDetailsData } = useSelector((state) => state.TaskDetailsReducer);
  const projectHeaderDetails = TaskDetailsData?.ArtworkAgilityTasks?.[0];

  const arrTaskList = taskListOptions || [];

  const handleChange = (e) => {
    const value = e.target.value;
    const validInput = validateUBDSpecialChar(value);
    if (validInput) {
      setErrorAlert(false);
    } else {
      setErrorAlert(true);
    }
    setFullkitName(e.target.value);
  };

  const handleFullkitNameAccept = () => {
    setIsEditMode && setIsEditMode(false)
    setInitialFullkitName(fullkitName)
  }

  const handleFullkitNameCancel = () => {
    setIsEditMode && setIsEditMode(false)
    setFullkitName(initialFullkitName)
  }

  return (
    <div className="mb-3">
      <div className="project-details">
        <div className="mb-4">
          <label>Project Name</label>
          <button onClick={() => handleProjectNameClick()}>{projectName || projectHeaderDetails?.Project_Name}</button>
        </div>
        {isTaskPage && (
          <div className="fullkit-task-info">
            <p>
              <label>Duration</label>
              <span>{projectHeaderDetails?.Duration}</span>
            </p>
            <p>
              <label>Start date</label>
              <span>{changeDateFormat(projectHeaderDetails?.Start_Date)}</span>
            </p>
            <p>
              <label>End date</label>
              <span>{changeDateFormat(projectHeaderDetails?.End_Date)}</span>
            </p>
            <p>
              <label>Left days</label>
              <span>{projectHeaderDetails?.Remaining_Work}</span>
            </p>
          </div>
        )}
      </div>
      <Row>
        <Col className="customFullkitName" md={4}>
          <div className="fullkitName-height-fix">
            {isEditMode ? (
              <div className="fullkit-container-editable">
                <div className="fullkit-item">
                  <input
                    type="text"
                    value={fullkitName}
                    placeholder="Enter Fullkit Name"
                    maxLength={textFieldMaxLength}
                    className="fullkitInput"
                    onChange={(e) => handleChange(e)}
                    disabled={CFKDesignDisabled}
                  />

                  <img
                    src={TickUBD}
                    alt="TickUBD logo"
                    onClick={() => handleFullkitNameAccept()}
                    disabled={CFKDesignDisabled}
                  />
                  <img
                    src={CrossUBD}
                    alt="CrossUBD logo"
                    onClick={() => handleFullkitNameCancel()}
                    disabled={CFKDesignDisabled}
                  />
                </div>
                <div>
                  <CharacterLimit field={fullkitName} maxLength={textFieldMaxLength} />
                </div>
              </div>
            ) : (
              <div className="fullkit-container">
                <div className="fullkitName">{fullkitName}</div>
                <img
                  src={editName}
                  alt="edit logo"
                  onClick={() =>
                    setIsEditMode
                      ? CFKDesignDisabled
                        ? setIsEditMode(false)
                        : setIsEditMode(true)
                      : null
                  }
                  className="edit-Icon"
                  disabled={CFKDesignDisabled}
                />
              </div>
            )}
            {errorAlert && <div className="special_char_alert">{spcialCharAlert}</div>}
          </div>
        </Col>
        <Col className="d-flex align-items-center" md={4}>
          <span className="custom-fullkit-for me-3">Custom Fullkit for </span>
          <MultiSelect
            value={selectedTaskList}
            onChange={(e) => setSelectedTaskList && setSelectedTaskList(e.value)}
            options={arrTaskList}
            forceSelection
            optionLabel="TaskName"
            filter
            filterDelay={400}
            placeholder="Search task(s)"
            disabled={CFKDesignDisabled || isTaskPage}
          />
        </Col>
      </Row>
    </div>
  );
}
